import React from 'react';
import IconBase from './IconBase';

const LogoutIcon = props => {
    return (
        <IconBase {...props}>
            <path d="M15.3,7.7L15.3,7.7c-0.4,0.4-0.4,1,0,1.4l1.9,1.9H10c-0.6,0-1,0.4-1,1l0,0c0,0.6,0.4,1,1,1h7.2l-1.9,1.9c-0.4,0.4-0.4,1,0,1.4l0,0c0.4,0.4,1,0.4,1.4,0l3.6-3.6c0.4-0.4,0.4-1,0-1.4l-3.6-3.6C16.3,7.3,15.7,7.3,15.3,7.7z"/>
            <path d="M15,18v1H7V5h8v1h2V5c0-1.1-0.9-2-2-2H7C5.9,3,5,3.9,5,5v14c0,1.1,0.9,2,2,2h8c1.1,0,2-0.9,2-2v-1H15z"/>
        </IconBase>
    )
}

export default LogoutIcon;